import { connect } from 'react-redux';
import { compose } from '@reduxjs/toolkit';
import { ComponentType } from 'react';
import { withTranslation } from 'react-i18next';


import { requestNavigation } from 'store/navigation/actions';
import withAccessControl from 'hoc/withAccessControl';
import { navigationReducerName } from 'store/navigation/reducer';

import { RootState } from 'store/rootReducer';

import AddBusinessUserPage from './AddBusinessUserPage.layout';

import { AddBusinessUserPageStateProps, AddBusinessUserPageDispatchProps } from './AddBusinessUserPage.types';


const mapStateToProps = (state: RootState): AddBusinessUserPageStateProps => ({
    enhancedCurrentLocation: state[navigationReducerName].currentLocation,
    //
});

const mapDispatchToProps = (dispatch): AddBusinessUserPageDispatchProps => ({
    dispatchRequestNavigation: ({ locationPathname, meta }) => dispatch(requestNavigation({ locationPathname, meta })),
    //
});


const decorate = compose<ComponentType>(
    withTranslation('accounts'),
    withAccessControl,
    connect(mapStateToProps, mapDispatchToProps),
);

export default decorate(AddBusinessUserPage);
